import React, { Component } from 'react';
import { Loading } from './Loading';

export class LoadingScreen extends Component {

  render() {
    return (
      <div className="demo-layout mdl-layout" style={{justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh'}}>
        <Loading />
      </div>
    );
  }
};
